import React, { useContext, useState } from 'react'
import { useLocation, useHistory } from "react-router-dom";
import { Grid, makeStyles, IconButton, Typography } from '@material-ui/core';
import { MenuIcon, ArrowBackIcon } from '../icons'
import { QuantityContext } from '../context'
import { Drawer, Notification } from './'

export default function Header(props){

    const location = useLocation();
    const history = useHistory();
    const classes = useStyles({location, ...props})()
    const { quantityState } = useContext(QuantityContext);
    const [open, setOpen] = useState(false);

    return(
    <>
        <Drawer open={open} setOpen={(value) => setOpen(value)} />
        <Grid container justify="space-between" alignItems="center" item sm={12} xs={12} style={{padding:"23px 12px 0 12px"}}>
            {
                location.pathname === '/' || 
                location.pathname === '/request' ||  
                location.pathname === '/history' || 
                location.pathname === '/profile' || 
                location.pathname === '/about-us'|| 
                location.pathname === '/support' ? 
                    <IconButton onClick={() => setOpen(!open)}><MenuIcon /></IconButton> : 
                location.pathname === '/sample' || 
                location.pathname === '/assign' || 
                location.pathname === '/laboratory' ||
                location.pathname === '/unio-support' ||
                location.pathname === '/lab-support' ? 
                    <IconButton onClick={() => history.goBack()}><ArrowBackIcon /></IconButton> : null
            }            
            <Typography style={{fontWeight:"600"}} component="h1" variant="h1" align="center">
            {
                location.pathname === '/'               ? 'Inicio' : 
                            location.pathname === '/sample' ? location.state.product.name ?? 'Producto' : 
                location.pathname === '/assign'         ? 'Asignar a' :
                location.pathname === '/request'        ? 'Solicitar muestras' :
                location.pathname === '/laboratory'     ? 'Laboratorio' :
                location.pathname === '/history'        ? 'Historial' :
                location.pathname === '/profile'        ? 'Perfil' :
                location.pathname === '/about-us'       ? 'Sobre Unio' :
                location.pathname === '/support'        ? 'Soporte' : 
                location.pathname === '/unio-support'   ? 'Soporte Unio' :
                location.pathname === '/lab-support'    ? 'Soporte Laboratorio' :
                null
            }
            </Typography>
            {
                location.pathname==="/" ? 
                <Notification /> :
                <div className={classes.btn2}  style={{}}>
                    <Typography component="h1" variant="h1" align="center">
                        <span>Cant.</span>
                        <span>{quantityState.quantity}</span>
                    </Typography>
                </div>
            }
        </Grid>
    </> 
    )
}

const useStyles = ({ location, ...props }) => makeStyles((theme) => ({
    btn1:{

    },
    btn2:{
        visibility: (location.state && location.state.hideQuantity) ||
                    location.pathname==="/" || 
                    location.pathname==="/assign" || 
                    location.pathname==="/request" ||
                    location.pathname==="/laboratory" ||
                    location.pathname==="/history" ||
                    location.pathname==="/profile" ||
                    location.pathname==="/about-us" || 
                    location.pathname==="/support" || 
                    location.pathname==="/unio-support" || 
                    location.pathname==="/lab-support" ? "hidden":"visible",
        position:"relative",
        '& h1':{
            fontWeight:"600", 
            display:"flex", 
            justifyContent:"center", 
            alignItems:"center"
        },
        '& span:nth-child(1)':{
            position:"absolute",
            left:-60,
            fontSize:"1rem",
        },
        '& span:nth-child(2)':{
            width:30, 
            height:30, 
            borderRadius:"50%", 
            backgroundColor:"#2196C0", 
            padding:5,
            color:"#FFF", 
            display:"flex", 
            justifyContent:"center",
            alignItems:"center",
            boxSizing:location.pathname === '/request' ? "border-box" : "content-box",
        }
    }
}));